import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

type DimensionState = {
  refetchHash: number;
  search?: string;
};

const initialState: DimensionState = {
  refetchHash: 0,
  search: undefined,
};

export const dimensionSlice = createSlice({
  initialState,
  name: "dimension",
  reducers: {
    sendRefetchSignal: (state) => {
      state.refetchHash = (state.refetchHash + 1) % 100;
    },
    setSearch: (state, action: PayloadAction<string>) => {
      state.search = action.payload;
    },
  },
});
